import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {useForm, useFormContext} from 'react-hook-form'
import {Select} from '../../../../../../components/UI/Select'
import {useParameters} from '../../../../hooks/central/useParameters'
import {yupResolver} from '@hookform/resolvers/yup'
import {addObservationSchema} from '../../../../schema/cleaningStatus'
import {CLEANING_STATUS_SERVICES} from '../../../../services/cleaning-status.service'
import {ShowSnackBar} from '../../../../../../util/functions'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  escaneoActividadId?: string
  onSuccess?: () => void
}

type FormValues = {
  imagen: FileList
  Comentarios: string
  MotivoId: string
  EscaneoActividadId: string
}

export const ModalAddObservation: FC<Props> = ({show, setShow, escaneoActividadId, onSuccess}) => {
  const [preview, setPreview] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const {typeReasons, getTypeReasons} = useParameters()
  const formContext = useFormContext()
  const observationNumber = formContext.watch('observationNumber')

  const handleClose = () => {
    reset()
    setPreview(null)
    setShow(false)
  }

  const {
    register,
    handleSubmit,
    reset,
    formState: {errors},
    control,
    watch,
    setValue,
  } = useForm<FormValues>({
    resolver: yupResolver(addObservationSchema),
    defaultValues: {
      Comentarios: '',
      MotivoId: '',
    },
  })
  const onSubmit = async (data: FormValues) => {
    try {
      setLoading(true)
      const dto = {
        EscaneoActividadId: escaneoActividadId,
        MotivoId: data.MotivoId,
        Comentarios: data.Comentarios,
      }

      const [observationResponse, imageResponse] = await Promise.all([
        CLEANING_STATUS_SERVICES.updateObservation(dto),
        data.imagen?.[0]
          ? (() => {
              const formData = new FormData()
              formData.append('Imagen', data.imagen[0])

              return CLEANING_STATUS_SERVICES.attachDocument(formData, escaneoActividadId || '')
            })()
          : Promise.resolve(null),
      ])

      if (!observationResponse.data.error && !imageResponse?.data?.error) {
        ShowSnackBar('Observación guardada exitosamente', 'success')
        handleClose()
        onSuccess?.()
        formContext.setValue('observationNumber', (observationNumber || 0) + 1)
      } else {
        ShowSnackBar('Error al guardar la observación', 'error')
      }
    } catch (error) {
      console.error('Error al guardar observación:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]

    if (file) {
      setPreview(URL.createObjectURL(file))
    } else {
      setPreview(null)
    }
  }

  useEffect(() => {
    if (show) {
      getTypeReasons(
        {pageNumber: 1, size: 200, tableName: 'LIMPIEZAMOTIVOOBS'},
        {},
        {idKey: 'id', labelKey: 'nombreCorto'},
      )
      setValue('EscaneoActividadId', escaneoActividadId || '')
    }
  }, [show])

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      size='xl'
      aria-hidden='true'
      onHide={handleClose}
      // centered
    >
      <div className='modal-content'>
        {/* HEADER */}
        <div className='modal-header'>
          <h5 className='modal-title'>Agregar Observación</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>

        {/* BODY */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='modal-body'>
            {/* COMENTARIO */}
            <div className='mb-5'>
              <label className='required'>Motivo:</label>
              <Select control={control as any} name='MotivoId' data={typeReasons} errors={errors} />
            </div>
            {/* COMENTARIO */}
            <div className='mb-5'>
              <label className='form-label'>Comentario:</label>
              <textarea
                className='form-control'
                rows={3}
                placeholder='Escribe un comentario...'
                {...register('Comentarios', {required: true})}
              />
            </div>
            {/* INPUT FOTO */}
            <div className='mb-5'>
              <label className='form-label'>Foto:</label>
              <input
                type='file'
                accept='image/*'
                capture='environment'
                className='form-control'
                {...register('imagen', {required: true})}
                onChange={handleImageChange}
              />
            </div>

            {/* PREVIEW */}
            {preview && (
              <div className='mb-5'>
                <img
                  src={preview}
                  alt='preview'
                  className='img-fluid rounded'
                  style={{
                    maxHeight: 300,
                    objectFit: 'cover',
                  }}
                />
              </div>
            )}
          </div>
          {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
          {/* FOOTER */}
          <div className='modal-footer'>
            <button type='button' className='btn btn-light' onClick={handleClose}>
              Cancelar
            </button>
            <button
              type='button'
              className='btn btn-primary'
              onClick={handleSubmit(onSubmit)}
              disabled={loading}
            >
              Guardar
            </button>
          </div>
        </form>
      </div>
    </Modal>
  )
}
